import SelectAssetsCombobox from '@/components/SelectAssetsCombobox';
import SendInputForm from './SendInputForm';
import SendCheckAmountBox from './SendCheckAmountBox';
import SendCheckBtn from './SendCheckBtn';
import * as ViewModel from '@/core/presenter/viewModel';
import SendInputMemo from './SendInputMemo';
import clsx from 'clsx';

interface IProps {
  isWritting: boolean;
  sendAddress: string;
  sendAsset: string;
  trxAsset: ViewModel.IAsset | undefined;
  tokenAsset: ViewModel.IAsset | undefined;
  selectedAsset: ViewModel.IAsset | undefined;
  curculateKrw: string;
  isSendCheckBtnDisabled: boolean;
  isInvalidAddressModalOpen: boolean;
  isBalanceNotEnoughModalOpen: boolean;
  isClipboardErrorModalOpen: boolean;
  defaultMemo: string;
  onChangeMemo: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onClickSendCancelBtn: () => void;
  onPaste: (text: string) => void;
  onChangeSendAddress: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangeSelectedAsset: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangeSelectedAssetValue: (assetType: ViewModel.AssetType) => void;
  onClickDeleteBtn: () => void;
  onClickResetAmountBtn: () => void;
  onClickSendCheckBtn: () => void;
  onClickInvalidAddressModalClose: () => void;
  onClickBalanceNotEnoughModalConfirm: () => void;
  onClickCameraBtn: () => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onSetMemo?: (memo: string) => void;
  memo: string;
  onClipboardError: () => void;
  onClickClipboardErrorModalClose: () => void;
}

const SendViewContent = ({
  isWritting,
  sendAddress,
  sendAsset,
  selectedAsset,
  curculateKrw,
  isSendCheckBtnDisabled,
  isInvalidAddressModalOpen,
  isBalanceNotEnoughModalOpen,
  isClipboardErrorModalOpen,
  defaultMemo,
  onChangeMemo,
  onClickSendCancelBtn,
  onClickSendCheckBtn,
  onClickInvalidAddressModalClose,
  onClickBalanceNotEnoughModalConfirm,
  onChangeSendAddress,
  onChangeSelectedAsset,
  onChangeSelectedAssetValue,
  onClickDeleteBtn,
  onClickResetAmountBtn,
  onPaste,
  onClickCameraBtn,
  onKeyPress,
  onSetMemo,
  memo,
  onClipboardError,
  onClickClipboardErrorModalClose,
}: IProps) => {
  return (
    <>
      <div className="send-content send-container send-filled-container">
        <div className="send-card">
          <h2 className="send-card-title text-lg font-semibold center">보낼 대상:</h2>
          <SendInputForm
            isWritting={isWritting}
            sendAddress={sendAddress}
            onPaste={onPaste}
            onChangeSendAddress={onChangeSendAddress}
            onClickDeleteBtn={onClickDeleteBtn}
            onClickCameraBtn={onClickCameraBtn}
            onSetMemo={onSetMemo}
            onClipboardError={onClipboardError}
          />
          <SendInputMemo isWritting={isWritting} defaultMemo={defaultMemo} memo={memo} onChangeMemo={onChangeMemo} />
          <SelectAssetsCombobox
            selectedAsset={selectedAsset}
            isWritting={isWritting}
            onChangeSelectedAssetValue={onChangeSelectedAssetValue}
          />
          <SendCheckAmountBox
            selectedAsset={selectedAsset}
            curculateKrw={curculateKrw}
            isWritting={isWritting}
            sendAsset={sendAsset}
            onChangeSelectedAsset={onChangeSelectedAsset}
            onClickResetAmountBtn={onClickResetAmountBtn}
            onKeyPress={onKeyPress}
          />
        </div>
        <SendCheckBtn
          isWritting={isWritting}
          isSendCheckBtnDisabled={isSendCheckBtnDisabled}
          isInvalidAddressModalOpen={isInvalidAddressModalOpen}
          isBalanceNotEnoughModalOpen={isBalanceNotEnoughModalOpen}
          onClickSendCheckBtn={onClickSendCheckBtn}
          onClickSendCancelBtn={onClickSendCancelBtn}
          onClickInvalidAddressModalClose={onClickInvalidAddressModalClose}
          onClickBalanceNotEnoughModalConfirm={onClickBalanceNotEnoughModalConfirm}
        />
      </div>

      {/* 클립보드 에러 모달 */}
      <div
        className={clsx('modal-overlay', !isClipboardErrorModalOpen && 'hidden')}
        id="clipboardErrorModal"
      >
        <div className="modal-content modal-medium">
          <button type="button" className="modal-close" onClick={onClickClipboardErrorModalClose}>
            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
          </button>

          <div className="modal-body">
            <div className="modal-icon-warning">
              <img src="./images/alert-icon.png" alt="경고" className="modal-icon" />
            </div>

            <h2 className="modal-warning-title text-lg font-bold">
              클립보드를 지원하지 않는<br />브라우저입니다.
            </h2>

            <button
              type="button"
              className="modal-button text-lg font-semibold"
              onClick={onClickClipboardErrorModalClose}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendViewContent;
